import Swal from 'sweetalert2';
export function ShowInfoSwal(status: number, message: string, title: string) {

let iconSwal: "success" | "error" | "warning" | "info" | "question" = 'info';

switch (status) {
    case 1:
      iconSwal = 'success';
      break;
    case 2:
      iconSwal = 'error';
      break;
    default:
      iconSwal = 'info';
  }

  return Swal.fire({
    icon: iconSwal,
    text: message,
    title: title,
    allowOutsideClick: false,
    showConfirmButton: true,
  });
}
